/**
 * Registro del service worker — `ADR-0004` (PWA de shell).
 *
 * El shell se cachea para que la aplicación abra rápido y también sin
 * conexión. Los datos NO: eso es `public/sw.js`, no este fichero.
 *
 * En desarrollo no se registra: un shell cacheado sirviendo una versión
 * antigua contra una API que ya cambió es exactamente el modo de fallo que
 * `ADR-0004` deja anotado como riesgo residual.
 */
export function registrarServiceWorker(): void {
  if (import.meta.env.DEV) return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      // Sin service worker la aplicación funciona igual: pierde el arranque
      // en frío rápido, no una función. No se molesta al usuario con esto.
    });
  });
}
